import React from "react";

import * as S from "./styles";

const Alert = () => {
  return (
    <S.Container>
      <S.Text>
        <strong>Nota:</strong> Ative as permissões para cada processadora (Dock
        e/ou Cards) conforme necessário. É possível ativar ambas as
        processadoras simultaneamente para uma mesma permissão.
      </S.Text>
    </S.Container>
  );
};

export default Alert;
